module.exports = __webpack_public_path__ + "img/mar.60fbc221.svg";